import React, { useState } from "react";
import { useLocation } from "react-router-dom";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenuAndNavigate = (hash) => {
    if (location.pathname !== "/") {
      window.location.href = `/${hash}`;
    } else {
      document.getElementById(hash.replace("#", ""))?.scrollIntoView({ behavior: "smooth" });
    }
    setIsMenuOpen(false);
  };

  const handleOutsideClick = (e) => {
    if (e.target.id === "menu-overlay") {
      setIsMenuOpen(false);
    }
  };

  return (
    <div>
      <header className="bg-gray-900/95 backdrop-blur-sm py-2 shadow-lg shadow-purple-900/20 sticky top-0 z-50 border-b border-gray-800">
        <div className="container mx-auto flex justify-between items-center px-4 sm:px-6">
          <div className="flex items-center gap-3">
            <img
              src="/logo1.png"
              alt="Edit Ezy Logo"
              className="w-12 h-12 sm:w-16 sm:h-16 object-cover"
            />
            <span className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent hidden sm:block">
              Edit Ezy
            </span>
          </div>

          <div className="hidden md:flex space-x-6 items-center">
            <a href="/" className="text-gray-300 hover:text-purple-400 font-medium text-sm transition-colors duration-200">HOME</a>
            <button onClick={() => closeMenuAndNavigate("#features")} className="text-gray-300 hover:text-purple-400 font-medium text-sm transition-colors duration-200">FEATURES</button>
            <a href="/price" className="text-gray-300 hover:text-purple-400 font-medium text-sm transition-colors duration-200">PRICING</a>
            <button onClick={() => closeMenuAndNavigate("#aboutus")} className="text-gray-300 hover:text-purple-400 font-medium text-sm transition-colors duration-200">ABOUT US</button>
            <button onClick={() => closeMenuAndNavigate("#whyus")} className="text-gray-300 hover:text-purple-400 font-medium text-sm transition-colors duration-200">WHY US</button>
            <button onClick={() => closeMenuAndNavigate("#contactus")} className="text-gray-300 hover:text-purple-400 font-medium text-sm transition-colors duration-200">CONTACT US</button>
            
            <a href="/price">
              <button className="bg-gradient-to-r from-purple-600 to-pink-600 text-white py-2 px-6 rounded-full font-semibold text-sm hover:from-purple-700 hover:to-pink-700 transition-all duration-300 transform hover:scale-105 shadow-lg shadow-purple-500/25">
                Purchase - ₹499/yr
              </button>
            </a>
          </div>

          <div className="md:hidden flex items-center">
            <button onClick={toggleMenu} className="text-gray-300 focus:outline-none hover:text-purple-400 transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </header>

      {isMenuOpen && (
        <div id="menu-overlay" onClick={handleOutsideClick} className="fixed inset-0 bg-black bg-opacity-70 z-40 backdrop-blur-sm">
          <div className="fixed right-0 top-0 w-3/5 bg-gray-900 h-full shadow-2xl transform transition-transform duration-300 ease-in-out pt-20 pb-6 border-l border-gray-800">
            <div className="flex flex-col items-center space-y-6">
              <button onClick={() => closeMenuAndNavigate("#home")} className="text-gray-300 hover:text-purple-400 font-semibold text-lg transition-colors">HOME</button>
              <button onClick={() => closeMenuAndNavigate("#features")} className="text-gray-300 hover:text-purple-400 font-semibold text-lg transition-colors">FEATURES</button>
              <a href="/price" className="text-gray-300 hover:text-purple-400 font-semibold text-lg transition-colors">PRICING</a>
              <button onClick={() => closeMenuAndNavigate("#aboutus")} className="text-gray-300 hover:text-purple-400 font-semibold text-lg transition-colors">ABOUT US</button>
              <button onClick={() => closeMenuAndNavigate("#whyus")} className="text-gray-300 hover:text-purple-400 font-semibold text-lg transition-colors">WHY US</button>
              <button onClick={() => closeMenuAndNavigate("#contactus")} className="text-gray-300 hover:text-purple-400 font-semibold text-lg transition-colors">CONTACT US</button>
              <a href="/price">
                <button className="bg-gradient-to-r from-purple-600 to-pink-600 text-white py-3 px-8 rounded-full font-semibold mt-4 hover:shadow-lg hover:shadow-purple-500/25 transition-all">
                  Purchase - ₹499/yr
                </button>
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;